import { render, staticRenderFns } from "./TopicWrapper.vue?vue&type=template&id=4a0e4f21&scoped=true"
import script from "./TopicWrapper.vue?vue&type=script&lang=js"
export * from "./TopicWrapper.vue?vue&type=script&lang=js"
import style0 from "./TopicWrapper.vue?vue&type=style&index=0&id=4a0e4f21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0e4f21",
  null
  
)

export default component.exports